var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "140px",
    height: "140px",
    viewBox: "0 0 140 140",
    style: {
      enableBackground: "new 0 0 140 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M70,130c-33.084,0-60-26.917-60-60s26.916-60,60-60s60,26.917,60,60S103.084,130,70,130z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2F3B55"
    },
    cx: 70,
    cy: 70,
    r: 58.064
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF9D5"
    },
    d: "M83.635,97.365c0,0.535-0.434,0.968-0.968,0.968H55.603c-0.534,0-0.968-0.433-0.968-0.968V52.301 c0-0.535,0.434-0.968,0.968-0.968h27.064c0.534,0,0.968,0.433,0.968,0.968V97.365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E0C0"
    },
    d: "M83.195,51.333H69.635v48h13.561c0.534,0,1.439-0.733,1.439-1.269V81.612V52.58 C84.635,52.045,83.729,51.333,83.195,51.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF9D5"
    },
    d: "M69.635,53.548c-0.535,0-1-0.433-1-0.968v-3.871c0-0.535,0.465-0.968,1-0.968s1,0.433,1,0.968 v3.871C70.635,53.115,70.17,53.548,69.635,53.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE7BD"
    },
    d: "M83.549,82.333H80.57c-2.358,0-4.937-2.11-4.937-4.422v-3.354c0-0.816-0.058-1.224-1.764-1.224 h-0.969c-1.706,0-2.269,0.406-2.269,1.224v3.354c0,2.246-1.146,4.422-3.538,4.422h-0.968c-2.392,0-4.494-2.177-4.494-4.422v-5.03 c0-2.046-0.281-2.547-2.498-2.547h-2.686c-0.534,0-1.816-0.766-1.816-1.301V52.581c0-0.535,1.282-1.247,1.816-1.247h27.098 c0.534,0,1.086,0.712,1.086,1.247v29.032C84.635,82.146,84.083,82.333,83.549,82.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2CCA7"
    },
    d: "M83.549,51.333H69.635v29.899c1-0.902,1-2.136,1-3.322v-3.354c0-0.816,0.563-1.224,2.269-1.224 h0.969c1.706,0,1.764,0.406,1.764,1.224v3.354c0,2.313,2.577,4.422,4.937,4.422h2.979c0.534,0,1.086-0.186,1.086-0.721V52.579 C84.635,52.045,84.083,51.333,83.549,51.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9E293B"
    },
    d: "M98.233,108.333H41.768c-0.413,0-0.781-0.074-0.916-0.465l-3.322-9.583 c-0.102-0.296-0.055-0.458,0.129-0.711c0.182-0.254,0.475-0.24,0.786-0.24h63.111c0.313,0,0.605,0.033,0.787,0.287 c0.183,0.254,0.229,0.521,0.129,0.816l-3.322,9.459C99.016,108.288,98.646,108.333,98.233,108.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCF47"
    },
    d: "M70,46.774c-3.256,0-5.808-2.551-5.808-5.807c0-2.886,2.016-7.345,5.271-9.515 c0.297-0.198,0.68-0.217,0.993-0.048c0.314,0.168,0.512,0.496,0.512,0.854c0,1.974,1.304,3.364,2.564,4.708 c1.17,1.247,2.273,2.424,2.273,4.001C75.807,44.223,73.256,46.774,70,46.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#802130"
    },
    d: "M102.343,97.62c-0.182-0.254-0.475-0.287-0.787-0.287H69.635v11h28.599 c0.413,0,0.782-0.074,0.916-0.466l3.322-9.524C102.572,98.048,102.525,97.874,102.343,97.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6BA40"
    },
    d: "M73.531,36.966c-1.261-1.344-2.563-2.734-2.563-4.708c0-0.357-0.379-0.685-0.694-0.854 c-0.143-0.077,0.361-0.109-0.639-0.109v15.479c4,0,5.989-2.551,5.989-5.807C75.624,39.39,74.702,38.212,73.531,36.966z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.205b3644.svg";
export { ForwardRef as ReactComponent };